import { CollaborativeAgreementRejectionReason, CollaborativeStateDetails, License, UserSuffix } from '@uplift/api';
import { DateFormats } from '@uplift/constants';
import { CalendarDateService } from '@uplift/services';

export const collaborativeAgreementRejectionReasonLabels: Record<CollaborativeAgreementRejectionReason, string> = {
  not_board_certified_psychiatrist: 'Collaborating physician is not a board-certified psychiatrist',
  expired_or_outside_date_range: 'Agreement is expired or outside the acceptable date range',
  not_signed_by_both_parties: 'Agreement is not signed by both parties',
  missing_state_name: 'Agreement is missing the state name',
  different_company: 'Agreement is for a different company',
  other: 'Other',
};

export const collaborativeAgreementRejectionReasonText = (
  reason: CollaborativeAgreementRejectionReason | null,
  details: string | null,
): string => {
  if (!reason) return '';

  if (reason === 'other') {
    return details || collaborativeAgreementRejectionReasonLabels.other;
  }

  return collaborativeAgreementRejectionReasonLabels[reason];
};

export const licenseRequiresCollaborativeAgreement = (
  license: Pick<License, 'role'> | null | undefined,
  collaborativeStateDetails: Pick<CollaborativeStateDetails, 'requiresCollaborativeAgreement'> | null | undefined,
): boolean => !!(collaborativeStateDetails?.requiresCollaborativeAgreement && license?.role?.suffix === UserSuffix.PMHNP);

export const isLicenseExpired = (license: Pick<License, 'expiration'> | null | undefined): boolean =>
  !!license?.expiration && CalendarDateService.date(license.expiration).isBefore(CalendarDateService.date(), 'day');

export const getDefaultDate = (date: Date | string) =>
  CalendarDateService.date(date, DateFormats.DEFAULT_DATE)
    .format(DateFormats.ISO_DATE)
    .toString();
